import { Tooltip } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption5 = {
  styleId:5,
  pluginName: [],
  refreshTime: 90000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "" //不带坐标系
  },
  color: [
    "rgb(0, 71, 255)",
    "rgb(0, 228, 228)",
    "rgb(255, 166, 63)",
    "rgb(214, 39, 176)",
    "rgb(192, 53, 227)",
    "rgb(128, 44, 245)",
    "rgb(139, 255, 74)",
    "rgb(255, 164, 41)",
    "rgb(255, 92, 90)",
    "rgb(255, 88, 199)",
    "rgb(83, 255, 172)",
    "rgb(255, 249, 31)",
    "rgb(65, 255, 209)",
    "rgb(109, 92, 255)",
    "rgb(0, 137, 255)",
    "rgb(255, 105, 105)",
    "rgb(131, 255, 125)",
    "rgb(78, 219, 255)",
    "rgb(227, 255, 89)",
    "rgb(183, 0, 255)"
  ],
  title: {
    text: "title",
    left: "center",
    show: false
  },
  tooltip: new Tooltip("item", {}),
  legend: {
    selectedMode: false, //图例禁止点击
    orient: "vertical",
    x: "85%",
    y: "55%",
    itemWidth: 18,
    itemHeight: 10,
    textStyle: {
      color: "#B3B5B7",
      fontStyle: "normal",
      fontWeight: "normal",
      fontFamily: "sans-serif",
      fontSize: 12
    }
  },
  series: [
    {
      name: "数据",
      type: "pie",
      roseType: "area",
      radius: ["10%", "120%"],
      center: ["43%", "90%"],
      startAngle: 180,
      itemStyle: {
        borderRadius: 0,
        borderColor: "rgba(0,0,0,0.5)",
        borderType: "solid",
        borderWidth: 0
      },
      label: {
        show: false,
        position: "outside",
        formatter: "{b}",
        fontFamily: "sans-serif",
        color: "rgba(255,255,255,1)",
        fontWeight: "400",
        fontSize: 14
      },
      labelLine: {
        show: true,
        lineStyle: {
          color: null,
          width: 1,
          type: "solid"
        }
      },
      data: [
        {
          value: 100,
          name: "数据1",
          itemStyle: {
            color: "rgb(0, 71, 255)"
          }
        },
        {
          value: 80,
          name: "数据2",
          itemStyle: {
            color: "rgb(0, 228, 228)"
          }
        },
        {
          value: 60,
          name: "数据3",
          itemStyle: {
            color: "rgb(255, 166, 63)"
          }
        },
        {
          value: 40,
          name: "数据4",
          itemStyle: {
            color: "rgb(214, 39, 176)"
          }
        },
        {
          value: 20,
          name: "数据5",
          itemStyle: {
            color: "rgb(192, 53, 227)"
          }
        },
        {
          name: null,
          value: 0,
          // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
          itemStyle: {
            color: "rgba(0,0,0,0)"
          },
          tooltip: {
            show: false,
            formatter: null
          }
        },
        {
          name: null,
          value: 0,
          // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
          itemStyle: {
            color: "rgba(0,0,0,0)"
          },
          tooltip: {
            show: false,
            formatter: null
          }
        },
        {
          name: null,
          value: 0,
          // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
          itemStyle: {
            color: "rgba(0,0,0,0)"
          },
          tooltip: {
            show: false,
            formatter: null
          }
        },
        {
          name: null,
          value: 0,
          // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
          itemStyle: {
            color: "rgba(0,0,0,0)"
          },
          tooltip: {
            show: false,
            formatter: null
          }
        },
        {
          name: null,
          value: 0,
          // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
          itemStyle: {
            color: "rgba(0,0,0,0)"
          },
          tooltip: {
            show: false,
            formatter: null
          }
        }
      ]
    },
    {
      type: "gauge",
      radius: "120%",
      center: ["43%", "90%"],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 1,
      splitNumber: 0,
      axisLine: {
        lineStyle: {
          width: 1,
          color: [[1, "#343A40"]]
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        fontSize: 0,
        offsetCenter: [0, "0%"],
        valueAnimation: true,
        formatter: function () {
          return ""
        },
        color: "auto"
      },
      data: []
    },
    {
      type: "gauge",
      radius: "100%",
      center: ["43%", "90%"],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 1,
      axisLine: {
        lineStyle: {
          width: 1,
          color: [[1, "#343A40"]]
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      data: []
    },
    {
      type: "gauge",
      radius: "78%",
      center: ["43%", "90%"],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 1,
      axisLine: {
        lineStyle: {
          width: 1,
          color: [[1, "#343A40"]]
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      title: {
        show: false,
        offsetCenter: [0, "-20%"],
        fontSize: 30
      },
      detail: {
        fontSize: 0,
        offsetCenter: [0, "0%"],
        valueAnimation: true,
        formatter: function () {
          return ""
        },
        color: "auto"
      },
      data: []
    },
    {
      type: "gauge",
      radius: "56%",
      center: ["43%", "90%"],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 1,
      axisLine: {
        lineStyle: {
          width: 1,
          color: [[1, "#343A40"]]
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      detail: {
        fontSize: 0,
        offsetCenter: [0, "0%"],
        valueAnimation: true,
        formatter: function () {
          return ""
        },
        color: "auto"
      },
      data: []
    },
    {
      type: "gauge",
      radius: "34%",
      center: ["50%", "90%"],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 1,
      splitNumber: 0,
      axisLine: {
        lineStyle: {
          width: 1,
          color: [[1, "#343A40"]]
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      detail: {
        show: false,
        fontSize: 0,
        offsetCenter: [0, "0%"],
        valueAnimation: true,
        formatter: function () {
          return ""
        },
        color: "auto"
      },
      data: []
    }
  ]
}
